import { ATS_ConflictResolution } from './ATS_ConflictResolution/ATS_ConflictResolution.js';
export const ATSGroup_ConflictResolution = [
    ATS_ConflictResolution.screen,
];
//# sourceMappingURL=index.js.map